import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPricing',
  setup(__props) {

const PricingBlock = defineAsyncComponent(() => import("@/components/theme/ecommerce/pricing/PricingBlock.vue"))
const SimplePricing = defineAsyncComponent(() => import("@/components/theme/ecommerce/pricing/SimplePricing.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "ECommerce",
      mains: "Pricing",
      title: "Pricing"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(PricingBlock)),
          _createVNode(_unref(SimplePricing))
        ])
      ])
    ])
  ], 64))
}
}

})